/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import ouiStyle from '@goldwasserexchange/oui-style';
import * as React from 'react';

const style: ouiStyle.InStyle = {
  display: ouiStyle.Constants.DisplayProp.flex,
  alignItems: ouiStyle.Constants.AlignItemsProp.end,
  justifyContent: ouiStyle.Constants.JustifyContentProp.end,
  widthLines: '1/2',
  color: ouiStyle.Constants.Colors.primary,
  textAlign: 'right',
  paddingLeft: 'simple',
  paddingRight: 3 / 8,
  whiteSpace: ouiStyle.Constants.WhiteSpaceProperty.noWrap,
};

const css = ouiStyle.makeCss(style);

export const LinkedBondDetailLineLabelContainer = (props: React.PropsWithChildren<{}>) => {
  const {
    children,
  } = props;
  return (
    <div
      css={css}
    >
      {children}
    </div>
  );
};
